export default "__VITE_ASSET__BZ5nu4fR__"